import React, { useState, useMemo } from 'react';
import {
  Smile,
  User,
  Dog,
  Apple,
  Car,
  Trophy,
  Lightbulb,
  Music,
  Flag,
  Search,
  X
} from 'lucide-react';
import { clsx } from 'clsx';

interface Category {
  id: string;
  name: string;
  icon: React.ElementType;
  emojis: string[];
}

const CATEGORIES: Category[] = [
  {
    id: 'smileys',
    name: 'Smileys & Emotion',
    icon: Smile,
    emojis: ['😀','😃','😄','😁','😆','😅','🤣','😂','🙂','🙃','😉','😊','😇','🥰','😍','🤩','😘','😗','😚','😋','😛','😜','🤪','🤨','🧐','🤓','😎','🥸','🥳','😏','😒','😞','😔','😟','😕','🙁','☹️','😮','😯','😲','😳','🥺','😦','😧','😨','😰','😥','😢','😭','😱','😖','😣','😞','😓','😩','😫','🥱','😤','😡','😠','🤬','😈','👿','💀','☠️','💩','🤡']
  },
  {
    id: 'people',
    name: 'People & Body',
    icon: User,
    emojis: ['👋','🤚','🖐','✋','🖖','👌','🤌','🤏','✌️','🤞','🤟','🤘','🤙','👈','👉','👆','🖕','👇','☝️','👍','👎','✊','👊','🤛','🤜','👏','🙌','👐','🤲','🤝','🙏','✍️','💅','🤳','💪','🦾','🦵','🦿','🦶','👂','🦻','👃','🧠','🫀','🫁','🦷','🦴','👀','👁','👅','👄']
  },
  {
    id: 'animals',
    name: 'Animals & Nature',
    icon: Dog,
    emojis: ['🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐻‍❄️','🐨','🐯','🦁','🐮','🐷','🐽','🐸','🐵','🙈','🙉','🙊','🐒','🐔','🐧','🐦','🐤','🐣','🐥','🦆','🦢','🦉','🦤','🪶','🦅','🦋','🐌','🐞','🐜','🦟','🪰','🪱','🐢','🐍','🦎','🦖','🦕','🐙','🦑','🦐','🦞','🦀','🐡','🐠','🐟','🐬']
  },
  {
    id: 'food',
    name: 'Food & Drink',
    icon: Apple,
    emojis: ['🍏','🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🫐','🍈','🍒','🍑','🥭','🍍','🥥','🥝','🍅','🍆','🥑','🥦','🥬','🥒','🌽','🥕','🫒','🧄','🧅','🥔','🍠','🥐','🥯','🍞','🥖','🥨','🧀','🥚','🍳','🧈','🥓','🥩','🍗','🍖','🍔','🍟','🍕','🌭','🥪','🌮','🌯']
  },
  {
    id: 'travel',
    name: 'Travel & Places',
    icon: Car,
    emojis: ['🚗','🚕','🚙','🚌','🚎','🏎','🚓','🚑','🚒','🚐','🛻','🚚','🚛','🚜','🛵','🚲','🛴','🚏','🛣','🛤','⛽️','🚨','🚥','🚦','🛑','🚧','⚓️','⛵️','🚤','🛳','⛴','🚢','✈️','🛩','🛫','🛬','🪂','💺','🚁','🚟','🚠','🚡','🛰','🚀','🛸','🛶','⛵️','🚢']
  },
  {
    id: 'activities',
    name: 'Activities',
    icon: Trophy,
    emojis: ['⚽️','🏀','🏈','⚾️','🥎','🎾','🏐','🏉','🥏','🎱','🪀','🏓','🏸','🏒','🏑','🥍','🏏','🪃','🥅','⛳️','🪁','🏹','🎣','🤿','🥊','🥋','🎽','🛹','🛼','🛷','⛸','🎿','🏂','🪂','🏋️‍♀️','🤼‍♀️','🤸‍♀️','⛹️‍♀️','🤺','🤾‍♀️','🏌️‍♀️','🏇','🧘‍♀️']
  },
  {
    id: 'objects',
    name: 'Objects',
    icon: Lightbulb,
    emojis: ['⌚️','📱','📲','💻','⌨️','🖥','🖨','🖱','🖲','🕹','🗜','💽','💾','💿','📀','📼','📷','📸','📹','🎥','📽','🎞','📞','☎️','📟','📠','📺','📻','🎙','🎚','🎛','🧭','⏱','⏲','⏰','🕰','⌛️','⏳','📡','🔋','🔌','💡','🔦','🕯','🪔','🧯','🛢','💸','💵','💴']
  },
  {
    id: 'symbols',
    name: 'Symbols',
    icon: Music,
    emojis: ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖','💘','💝','💟','☮️','✝️','☪️','🕉','☸️','✡️','🔯','🕎','☯️','☦️','🛐','⛎','♈️','♉️','♊️','♋️','♌️','♍️','♎️','♏️','♐️','♑️','♒️','♓️','🆔','⚛️','🉑','☢️','☣️','📴','📳']
  },
  {
    id: 'flags',
    name: 'Flags',
    icon: Flag,
    emojis: ['🏁','🚩','🎌','🏴','🏳️','🏳️‍🌈','🏳️‍⚧️','🏴‍☠️','🇦🇫','🇦🇱','🇩🇿','🇦🇸','🇦🇩','🇦🇴','🇦🇮','🇦🇶','🇦🇬','🇦🇷','🇦🇲','🇦🇼','🇦🇺','🇦🇹','🇦🇿','🇧🇸','🇧🇭','🇧🇩','🇧🇧','🇧🇾','🇧🇪','🇧🇿','🇧🇯','🇧🇲','🇧🇹','🇧🇴','🇧🇦','🇧🇼','🇧🇷','🇮🇴','🇻🇬','🇧🇳','🇧🇬','🇧🇫','🇧🇮','🇰🇭','🇨🇲','🇨🇦','🇮🇨','🇨🇻']
  }
];

const EMOJI_KEYWORDS: Record<string, string[]> = {
  '😀': ['smile','happy','grin','face'], '😃': ['smile','happy','grin','face'], '😄': ['smile','happy','grin','face'],
  '😁': ['smile','happy','grin','face'], '😆': ['smile','happy','laugh','face'], '😅': ['smile','happy','sweat','laugh'],
  '🤣': ['laugh','rofl','funny'], '😂': ['laugh','joy','funny'], '🙂': ['smile','happy'], '🙃': ['upside','smile'],
  '😉': ['wink','smile'], '😊': ['smile','happy','blush'], '😇': ['halo','angel','innocent'],
  '🥰': ['love','heart','smile','adore'], '😍': ['love','heart','eye','smile'], '🤩': ['star','struck','amazed'],
  '😘': ['kiss','love','heart'], '😗': ['kiss'], '😚': ['kiss','closed','eye'],
  '😋': ['yummy','savouring','food','tongue'], '😛': ['tongue'], '😜': ['wink','tongue','crazy'],
  '🤪': ['crazy','goofy','zany'], '🤨': ['eyebrow','thinking','hmm'], '🧐': ['monocle','thinking','smart'],
  '🤓': ['nerd','geek','glasses'], '😎': ['cool','sunglasses','chill'], '🥸': ['disguise','mask'],
  '🥳': ['party','celebrate','hat'], '😏': ['smirk','cool'], '😒': ['unamused','side','eye'],
  '😞': ['disappointed','sad'], '😔': ['pensive','sad'], '😟': ['worried','sad'], '😕': ['confused'],
  '🙁': ['frown','sad'], '☹️': ['frown','sad'], '😮': ['wow','surprise','mouth'], '😯': ['hush','surprise'],
  '😲': ['astonished','surprise'], '😳': ['flushed','blush','surprise'], '🥺': ['pleading','beg','sad','eyes'],
  '😦': ['frown','open'], '😧': ['anguished'], '😨': ['fear','scared'], '😰': ['anxious','sweat'],
  '😥': ['sad','relieved','sweat'], '😢': ['cry','sad','tear'], '😭': ['sob','cry','sad'],
  '😱': ['scream','fear','scared','wow'], '😖': ['confounded'], '😣': ['persevere'], '😓': ['sweat','sad'],
  '😩': ['weary','tired'], '😫': ['tired','weary'], '🥱': ['yawn','tired'], '😤': ['triumph','steam','nose'],
  '😡': ['rage','angry','mad'], '😠': ['angry','mad'], '🤬': ['swear','angry'],
  '😈': ['devil','horns'], '👿': ['imp','devil','angry'], '💀': ['skull','dead'], '☠️': ['poison','dead'],
  '💩': ['poop','shit'], '🤡': ['clown','funny'],
  '👋': ['wave','hello','hi','bye'], '👍': ['thumbs','up','like','good','yes'],
  '👎': ['thumbs','down','dislike','bad','no'], '👌': ['ok','good'], '✌️': ['peace','victory'],
  '🤞': ['fingers','crossed','luck'], '🤟': ['love','sign'], '🤘': ['rock','on','horns'],
  '🤙': ['call','hand'], '🙏': ['pray','please','thanks'], '🤝': ['shake','hand','deal'],
  '👏': ['clap','hand','bravo'], '🔥': ['fire','lit','hot'], '❤️': ['heart','love','like'],
  '✨': ['sparkle','magic','shiny'],
  '🐶': ['dog','puppy','pet'], '🐱': ['cat','kitten','pet'], '🐭': ['mouse','rat'],
  '🐹': ['hamster'], '🐰': ['rabbit','bunny'], '🦊': ['fox'], '🐻': ['bear'], '🐼': ['panda'],
  '🐯': ['tiger'], '🦁': ['lion'], '🐮': ['cow'], '🐷': ['pig'], '🐸': ['frog'], '🐵': ['monkey'],
  '💻': ['laptop','computer','mac','pc'], '📱': ['mobile','phone','iphone','android'],
  '📁': ['folder','file','directory'], '📂': ['folder','open'], '🏠': ['home','house'],
  '💼': ['briefcase','work','job'], '🚀': ['rocket','launch','ship'], '💡': ['lightbulb','idea','bright'],
  '🎨': ['art','paint','palette'], '📚': ['books','read','learn'], '⭐': ['star','favourite'],
  '📍': ['location','pin','map'], '🔔': ['bell','notification'], '⚙️': ['gear','settings','config']
};

interface EmojiPickerProps {
  onSelect: (emoji: string) => void;
}

export const EmojiPicker: React.FC<EmojiPickerProps> = ({ onSelect }) => {
  const [search, setSearch] = useState('');
  const [activeTab, setActiveTab] = useState(CATEGORIES[0].id);

  const filteredCategories = useMemo(() => {
    if (!search) return CATEGORIES;
    const searchLower = search.toLowerCase();
    return CATEGORIES.map(cat => {
      if (cat.name.toLowerCase().includes(searchLower)) return cat;
      const matchedEmojis = cat.emojis.filter(emoji => {
        const keywords = EMOJI_KEYWORDS[emoji] || [];
        return keywords.some(k => k.includes(searchLower)) || emoji.includes(searchLower);
      });
      return { ...cat, emojis: matchedEmojis };
    }).filter(cat => cat.emojis.length > 0);
  }, [search]);

  return (
    <div className="dropdown-menu-panel flex flex-col overflow-hidden rounded-2xl border border-border bg-card shadow-popover animate-in fade-in zoom-in-95 duration-200" style={{ width: '320px', height: '380px' }}>
      {/* Category Tabs */}
      <div className="flex items-center gap-1 p-2 bg-background border-b border-border overflow-x-auto no-scrollbar">
        {CATEGORIES.map((cat) => {
          const Icon = cat.icon;
          const isActive = activeTab === cat.id;
          return (
            <button
              type="button"
              key={cat.id}
              onClick={() => {
                setActiveTab(cat.id);
                setSearch('');
                const el = document.getElementById(`emoji-cat-${cat.id}`);
                el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }}
              className={clsx(
                'p-2 rounded-lg transition-all flex-shrink-0 relative group',
                isActive ? 'text-primary bg-primary/10' : 'text-muted-foreground hover:text-foreground hover:bg-muted'
              )}
              title={cat.name}
            >
              <Icon size={18} />
              {isActive && <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1 h-1 bg-primary rounded-full" />}
            </button>
          );
        })}
      </div>

      {/* Search Bar */}
      <div className="px-3 pt-3 pb-2">
        <div className="relative group">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" size={14} />
          <input
            type="text"
            placeholder="Enter emoji"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full bg-secondary border border-border rounded-xl py-2 pl-9 pr-8 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary/30 transition-all font-medium"
          />
          {search && (
            <button type="button" onClick={() => setSearch('')} className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-muted-foreground hover:text-foreground">
              <X size={14} />
            </button>
          )}
        </div>
      </div>

      {/* Emoji List */}
      <div className="overflow-y-auto px-3 pb-3" style={{ flex: '1 1 0', minHeight: 0 }}>
        {filteredCategories.length === 0 ? (
          <div className="py-10 text-center text-muted-foreground text-xs font-bold uppercase tracking-widest">No emojis found</div>
        ) : (
          filteredCategories.map((cat) => (
            <div key={cat.id} id={`emoji-cat-${cat.id}`} className="mb-4 last:mb-0">
              <h3 className="text-[10px] font-bold text-muted-foreground uppercase tracking-widest mb-2 px-1">{cat.name}</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(0, 1fr))', gap: '4px' }}>
                {cat.emojis.map((_emoji, i) => (
                  <button
                    type="button"
                    key={`${cat.id}-${i}`}
                    onClick={() => onSelect(_emoji)}
                    className="flex items-center justify-center text-xl hover:bg-muted rounded-lg transition-all active:scale-90"
                    style={{ aspectRatio: '1 / 1' }}
                  >
                    {_emoji}
                  </button>
                ))}
              </div>
            </div>
          ))
        )}
      </div>

      <style>{`.no-scrollbar::-webkit-scrollbar{display:none}.no-scrollbar{-ms-overflow-style:none;scrollbar-width:none}`}</style>
    </div>
  );
};
